import { Menu } from "lucide-react";
import { Link, NavLink } from "react-router-dom";
import { tableBooker } from "../../constants/routing";
import { Button } from "../ui/button";
import { siteNavItems } from "./site-nav";
import logoLight from "../../assets/svg/logo_w.svg?url";

interface NavbarProps {
  isMobileMenuOpen: boolean;
  onToggleMobileMenu: () => void;
}

export function Navbar({ isMobileMenuOpen, onToggleMobileMenu }: NavbarProps) {
  return (
    <nav className="fixed inset-x-0 top-[var(--notification-bar-h,0px)] z-50 border-b border-white/10 bg-black/55 backdrop-blur-xl">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-20 items-center justify-between gap-4">
          <div className="shrink-0">
            <Link to="/">
              <img src={logoLight} alt="La Piazza" className="h-10 w-auto" />
            </Link>
          </div>

          <div className="hidden items-center gap-6 lg:flex">
            {siteNavItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  isActive
                    ? "font-display text-sm font-light tracking-wider text-accent"
                    : "font-display text-sm font-light tracking-wider text-white/80 transition-colors hover:text-white"
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Button asChild className="bg-accent text-[#1f1a12] hover:bg-accent-dark">
              <a href={tableBooker} target="_blank" rel="noreferrer">
                Reserveer nu
              </a>
            </Button>
          </div>

          <div className="lg:hidden">
            <button
              onClick={onToggleMobileMenu}
              className="rounded-full border border-white/20 bg-white/10 p-3 text-white shadow-sm transition-colors hover:border-white/40 hover:bg-white/20"
              aria-expanded={isMobileMenuOpen}
              aria-label={isMobileMenuOpen ? "Sluit navigatie" : "Open navigatie"}
            >
              <Menu className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
